<template>
  <div>
    <v-form v-model="form.valid" ref="form">
      <v-row>
        <v-col cols="3">
          <v-combobox
            v-model="form.fields.keyword"
            :items="$autocompletion.get('keywords')"
            :rules="form.rules.keyword"
            :menu-props="{ auto: true, overflowY: true, disableKeys: true }"
            label="Mot(s)-clé(s)"
            required
            multiple
            hide-selected
            hide-no-data
            hide-details
            @keyup.enter.prevent="submit"
          ></v-combobox>
        </v-col>
        <v-col cols="3">
          <v-autocomplete
            v-model="form.fields.country"
            :items="$locale.countriesItems"
            hide-no-data
            hide-details
            label="Géolocalisation"
          ></v-autocomplete>
        </v-col>
        <v-col cols="2">
          <v-autocomplete
            v-model="form.fields.language"
            :items="$locale.languagesItems"
            hide-no-data
            hide-details
            label="Langue"
          ></v-autocomplete>
        </v-col>
        <v-col cols="1">
          <v-autocomplete
            v-model="form.fields.count"
            :items="[1, 5, 10, 20]"
            hide-no-data
            hide-details
            label="Requêtes"
          ></v-autocomplete>
        </v-col>
        <v-col cols="3">
          <v-btn
            color="success"
            :loading="$api.loading('crawler/inspection')"
            :disabled="!form.valid"
            @click="submit"
            block
            large
            style="height: 48px;">
            <v-icon left>mdi-magnify</v-icon>
            Analyser
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'CrawlerInspectionForm',
  props: ['config'],
  data () {
    return {
      form: {
        valid: false,
        fields: {
          keyword: '',
          language: 'en',
          country: 'en',
          count: 5,
        },
        rules: {
          keyword: [v => !!v]
        }
      },
    }
  },
  methods: {
    async submit () {
      if (this.$refs.form.validate()) {
        const response = await this.$api.post('crawler/inspection', {
          config: this.config,
          ...this.form.fields
        })

        this.$emit('created', response.data.hash)
      }
    }
  },
  mounted () {
    this.form.fields.language = this.$account.current.language
    this.form.fields.country = this.$account.current.country
  }
}
</script>

<style scoped>

</style>